import request from '@/utils/request'


// 查询森林等级列表
export function listLevel(query) {
  return request({
    url: '/forest/level/list',
    method: 'get',
    params: query
  })
}

// 查询森林等级分页
export function pageLevel(query) {
  return request({
    url: '/forest/level/page',
    method: 'get',
    params: query
  })
}

// 查询森林等级详细
export function getLevel(data) {
  return request({
    url: '/forest/level/detail',
    method: 'get',
    params: data
  })
}

// 新增森林等级
export function addLevel(data) {
  return request({
    url: '/forest/level/add',
    method: 'post',
    data: data
  })
}

// 修改森林等级
export function updateLevel(data) {
  return request({
    url: '/forest/level/edit',
    method: 'post',
    data: data
  })
}

// 删除森林等级
export function delLevel(data) {
  return request({
    url: '/forest/level/delete',
    method: 'post',
    data: data
  })
}
